import { useEffect, useMemo, useRef } from 'react';
import {
  CONTENT_DELIVERY_METHOD,
  CONTENT_PROVIDER_CANVAS,
  CONTENT_PROVIDER_CANVAS_LABELS,
  CONTENT_PROVIDER_D2L,
  CONTENT_PROVIDER_D2L_LABELS,
  CONTENT_PROVIDER_ESSENTIAL_ED,
  CONTENT_PROVIDER_ESSENTIAL_ED_LABELS,
  CategoryType
} from '../../../../../../services/constants';
import useUnleashHook from '../../../../../../core/unleash/useUnleashHook';
import UnleashService from '../../../../../../services/unleash/unleash.service';

const useProgramMetadataHook = (formData, handleChange, categories) => {
  const canvasLmsInManageProgramsEnabled = useUnleashHook(
    UnleashService.FLAGS.ENABLE_CANVAS_LMS_IN_MANAGE_PROGRAMS
  ).isFlagEnabled();
  const showBestDropdown = useUnleashHook(UnleashService.FLAGS.SHOW_BEST_DROPDOWN_IN_SUPER_ADMIN_TOOL).isFlagEnabled();
  
  const handleChangeRef = useRef(handleChange);
  useEffect(() => {
    handleChangeRef.current = handleChange;
  }, [handleChange]);
  
  useEffect(() => {
    if (formData?.contentDeliveryMethod === CONTENT_DELIVERY_METHOD.ESSENTIAL_ED) {
      handleChangeRef.current({
        target: {
          name: 'certificateEligibility',
          type: 'checkbox',
          checked: false
        }
      });
    }
  }, [formData?.contentDeliveryMethod]);

  const getContentDeliveryMethodOptions = () => {
    const options = [CONTENT_DELIVERY_METHOD.D2L, CONTENT_DELIVERY_METHOD.ESSENTIAL_ED];
    if (canvasLmsInManageProgramsEnabled) {
      options.push(CONTENT_DELIVERY_METHOD.CANVAS);
    }
    return options;
  };

  const getContentProviderOptions = (deliveryMethod) => {
    if (deliveryMethod === CONTENT_DELIVERY_METHOD.D2L) {
      return {
        options: Object.values(CONTENT_PROVIDER_D2L),
        labels: CONTENT_PROVIDER_D2L_LABELS
      };
    } else if (deliveryMethod === CONTENT_DELIVERY_METHOD.ESSENTIAL_ED) {
      return {
        options: Object.values(CONTENT_PROVIDER_ESSENTIAL_ED),
        labels: CONTENT_PROVIDER_ESSENTIAL_ED_LABELS
      };
    } else if (deliveryMethod === CONTENT_DELIVERY_METHOD.CANVAS) {
      return {
        options: Object.values(CONTENT_PROVIDER_CANVAS),
        labels: CONTENT_PROVIDER_CANVAS_LABELS
      };
    }
    return {
      options: [],
      labels: {}
    };
  };

  const extractCategoryData = (categoriesList, categoryType) => {
    if (!Array.isArray(categoriesList)) return { list: [], labels: {} };

    const names = categoriesList
      .filter(c => c?.type === categoryType)
      .map(c => c?.name || '')
      .filter(Boolean);

    const labels = names.reduce((acc, name) => {
      acc[name] = name;
      return acc;
    }, {});

    return { list: names, labels };
  };


  const { list: bestCategoriesList, labels: bestCategoriesLabels } = useMemo(
    () => extractCategoryData(categories, CategoryType.BEST),
    [categories]
  );

  return {
    getContentDeliveryMethodOptions,
    getContentProviderOptions,
    showBestDropdown,
    bestCategoriesList,
    bestCategoriesLabels
  };
};

export default useProgramMetadataHook;
